// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CitationAnnotations_FileParagraphFragment = { __typename?: 'FileParagraph', id: string, content: string, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string, name: string } | null } | null, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }> };

export type CitationAnnotationsQueryVariables = Types.Exact<{
  paragraphIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type CitationAnnotationsQuery = { __typename?: 'Query', getParagraphs: Array<(
    { __typename?: 'FileParagraph' }
    & CitationAnnotations_FileParagraphFragment
  )> };

export const Operations = {
  Query: {
    CitationAnnotations: 'CitationAnnotations' as const
  },
  Fragment: {
    CitationAnnotations_FileParagraph: 'CitationAnnotations_FileParagraph' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CitationAnnotations_FileParagraphFragmentDoc = gql`
    fragment CitationAnnotations_FileParagraph on FileParagraph {
  id
  content
  file {
    id
    pdfDocument {
      id
      name
    }
  }
  boundingRegions {
    PageNumber
    Polygon {
      x
      y
    }
  }
}
    `;
export const CitationAnnotationsDocument = gql`
    query CitationAnnotations($paragraphIds: [ID!]!) {
  getParagraphs(paragraphIDs: $paragraphIds) {
    ...CitationAnnotations_FileParagraph
  }
}
    ${CitationAnnotations_FileParagraphFragmentDoc}`;

/**
 * __useCitationAnnotationsQuery__
 *
 * To run a query within a React component, call `useCitationAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitationAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitationAnnotationsQuery({
 *   variables: {
 *      paragraphIds: // value for 'paragraphIds'
 *   },
 * });
 */
export function useCitationAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>(CitationAnnotationsDocument, withFetchPolicyContext(options));
      }
export function useCitationAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>(CitationAnnotationsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCitationAnnotationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>(CitationAnnotationsDocument, withFetchPolicyContext(options));
        }
export type CitationAnnotationsQueryHookResult = ReturnType<typeof useCitationAnnotationsQuery>;
export type CitationAnnotationsLazyQueryHookResult = ReturnType<typeof useCitationAnnotationsLazyQuery>;
export type CitationAnnotationsSuspenseQueryHookResult = ReturnType<typeof useCitationAnnotationsSuspenseQuery>;
export type CitationAnnotationsQueryResult = Apollo.QueryResult<CitationAnnotationsQuery, CitationAnnotationsQueryVariables>;